export default class {

  parent = null;
  cancellation = '';
  date = null;
  price = 0;
  allPrice = 0;
  hotel = 0;

  constructor(parent) {
    this.parent = parent;
  }

  set(data) {
    this.cancellation = data.cancellationConditions || '';
    this.price = data.price || 0;
    this.date = data.beginDateTime.value;
  }

  get servicePrice() {
    let sum = 0;
    const hotelPrice = this.parent.hotel.priceHotel;
    this.hotel = hotelPrice;
    const a = this.parent.additionalService.allActiveService.map(x => x.fullPrice);
    if (a.length) sum = a.reduce((acc, val) => acc + val);
    this.allPrice = sum + this.price + hotelPrice;
    return sum;
  }
}
